<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import i18n from "../../../../i18n";
import { servicehelpers } from "../../../../services/servicehelpers";
import { loanTemplateService } from "../../../../services/paymentservice/loantemplate.service";
import { settingService } from "../../../../services/settingservice/setting.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Loan Template",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "loan template",
      breadCrumb: {},

      interestWidth: 'col-md-12',
      payShow: false,
      durationShow: false,

      template: {},
      loanTypesList: {},
      decimalCalcTypeList: {},
      valueName: '',
      valueNameEn: '',
      valueLoanType: 0,
      valueDecimalCalcType: 0,
      valueInterest: 0,
      valueDuration: 0,
      valuePay: 0,

    };
  },
  mounted() {

    this.loadingLoanTypeData();
    this.loadingRoundingRuleData();
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  watch: {
      valueLoanType: function(newVal) { 

        if(this.loanTypesList.data) {
          this.loanTypeChanged(newVal);
        }
      }
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      loanTemplateService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.template = response.data;

          this.breadCrumb = {
            text: response.data.name,
            active: true,
          };

          this.valueName = this.template.name;
          this.valueNameEn = this.template.name_en;
          this.valueLoanType = this.template.loan_type_id;
          this.valueDecimalCalcType = this.template.decimal_calc_type_id;
          this.valueInterest = this.template.rate;
          this.valueDuration = this.template.number_month ? this.template.number_month : 0;
          this.valuePay = this.template.monthly_pay ? this.template.monthly_pay : 0;

          if(this.loanTypesList.data) {
            this.loanTypeChanged(this.valueLoanType);
          }


        });
    },

    loadingLoanTypeData: function() {
      settingService.getLoanTypeList()
        .then(response => {
          this.loanTypesList = response;

          this.loanTypeChanged(this.valueLoanType);
          

        });
    },

    loadingRoundingRuleData: function() {

      servicehelpers.getRoundingRuleData().then(response => {
        this.decimalCalcTypeList = response;
      });
    },

    loanTypeChanged: function(value) {
      let loanType = this.loanTypesList.data.find(item => item.id == value);

      if(loanType == null || loanType == undefined) {
        this.interestWidth = `col-md-12`;
        this.payShow = false;
        this.durationShow = false;
      } else {
        this.interestWidth = loanType.status == 1 || loanType.status == 2  ? `col-md-6` : 
                loanType.status == 3  ? `col-md-4` : `col-md-12`  ;

        this.payShow = loanType.status == 1 ? true : false;
        this.durationShow = loanType.status == 2 ? true : false;
      }
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;

      let loanTemplate = {
        name: this.valueName,
        name_en: this.valueNameEn,
        loan_type_id: this.valueLoanType,
        decimal_calc_type_id: this.valueDecimalCalcType,
        rate: this.valueInterest,
        monthly_pay: this.valuePay,
        number_month: this.valueDuration
      };

      console.log(JSON.stringify(loanTemplate))

      if(this.isAdd) {
        loanTemplateService.insert(loanTemplate).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-loan-template"
                });
              } 
            });

          }
        });
      } else {
        loanTemplateService.update(this.$route.params.id, loanTemplate).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-loan-template"
                });
              } 
            });

          }
        });
      }

    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.configuration.loan-template.text'),
        href: '/setting/loan-template',
      }, {
        text: $t('setting.configuration.loan-template.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.configuration.loan-template.new') : $t('setting.configuration.loan-template.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.configuration.loan-template.text'),
        href: '/setting/loan-template',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.configuration.loan-template.new') : $t('setting.configuration.loan-template.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />


    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :label="'setting.configuration.loan-template.name'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'text'"
                    :id="'name_en'"
                    v-model="valueNameEn"
                    :label="'setting.configuration.loan-template.name-en'"  />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                 <Select 
                    :id="'loan_type_id'"
                    :text="'name'"
                    :text2="'name_en'"
                    :required="true"
                    v-model="valueLoanType"
                    :list="this.loanTypesList"
                    :label="'setting.configuration.loan-template.type'"  />
              </div>
              <div class="col-md-6">
                 <Select 
                    :id="'decimal_calc_type_id'"
                    :text="'name'"
                    :required="true"
                    v-model="valueDecimalCalcType"
                    :list="this.decimalCalcTypeList"
                    :label="'setting.configuration.loan-template.round-role'"  />
              </div>
            </div>
            <div class="row">
              <div :class="interestWidth">
                 <Input 
                    :type="'number'"
                    :id="'rate'"
                    v-model="valueInterest"
                    :last="'general.percentag'"
                    :label="'setting.configuration.loan-template.rate'"  />
              </div>
              <div :class="interestWidth" v-show="payShow">
                 <Input 
                    :type="'number'"
                    :id="'monthly_pay'"
                    v-model="valuePay"
                    :last="'general.usd'"
                    :label="'setting.configuration.loan-template.monthly-pay'"  />
              </div>
              <div :class="interestWidth" v-show="durationShow">
                 <Input 
                    :type="'number'"
                    :id="'number_month'"
                    v-model="valueDuration"
                    :last="'general.month'"
                    :label="'setting.configuration.loan-template.duration'"  />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
              </div>
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
              </div>
            </div>

          </div>
        </div>

      </div>
    </b-form> 

  </Layout>
</template>